export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-lg p-6 md:p-10 border border-background-200/80">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">移动阅读</h2>
              <p className="text-sm text-foreground-600 mb-6 leading-relaxed">
                喵趣漫画全面适配移动端浏览器，无需下载安装即可享受原生般的下拉式阅读体验。
                打开手机浏览器访问喵趣漫画，韩漫日漫国漫随时随地想看就看。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
                <div className="flex items-center gap-2 bg-background-50 border border-background-300 rounded-md px-4 py-2.5 cursor-default">
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-apple-line text-xl text-foreground-700"></i>
                  </span>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-500">iOS Safari</div>
                    <div className="text-xs font-medium text-foreground-800">添加到主屏幕</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-background-50 border border-background-300 rounded-md px-4 py-2.5 cursor-default">
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-android-line text-xl text-foreground-700"></i>
                  </span>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-500">Android Chrome</div>
                    <div className="text-xs font-medium text-foreground-800">添加到主屏幕</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20webtoon%20comic%20reading%20interface%20on%20screen%2C%20vertical%20scroll%20reading%20mode%2C%20clean%20modern%20phone%20design%2C%20warm%20cozy%20background%20with%20soft%20lighting%2C%20minimalist%20product%20photography%20style%2C%20Korean%20webtoon%20art%20visible%20on%20screen&width=400&height=700&seq=app-mockup&orientation=portrait"
                alt="喵趣漫画移动端下拉式阅读体验 - 手机浏览器直接访问"
                className="w-52 h-auto rounded-lg"
                width="400"
                height="700"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}